export default __webpack_public_path__ + "ac63908fd52b70c42df29449d62aac83.png";